import styled from 'styled-components';
import { FC } from 'react';
import { getThemeColor } from '../../styles/Theme';
import { PrimaryButton } from '../common/StyledButton';
import { LinkedInIcon } from '../icons/LinkedInIcon';
import { XingIcon } from '../icons/XingIcon';
import { TwitterIcon } from '../icons/TwitterIcon';
import { LinkIcon } from '../icons/LinkIcon';

const Wrapper = styled.div`
  display: flex;
`;

const ShareItem = styled(PrimaryButton)`
  height: 3rem;
  width: 3rem;
  padding: 0;
  
  background-color: ${getThemeColor('purple')};
  
  &:not(last-of-type) {
    margin-right: .625rem;
  }
  
  svg {
    width: 1.5rem;
    height: 1.5rem;
    
    path {
      fill: ${getThemeColor('white')};
      transition-duration: .25s;
    }
  }

  &:hover {
    svg {
      path {
        fill: ${getThemeColor('green')};
      }
    }
  }

  &.linkedin {
    svg {
      width: 1.375rem;
      height: 1.375rem;
    }
  }
`;

interface Props {
  type?: string;
  title?: string;
  company?: string;
  slug?: string;
}

export const ShareMenu: FC<Props> = (props) => {
  const {
    type,
    title,
    company,
    slug,
  } = props;

  const shareUrl = slug ? window.location.origin + '/' + (type === 'job' ? 'job/' : '') + slug : window.location.href.split('?')[0];

  const LinkText = () => {
    switch(type) {
      case 'job':
        return 'Jetzt Stellenangebot auschecken! 👇 ' + title + ' bei ' + company;
      case 'blog':
        return 'Lies jetzt den Artikel "' +  title + '" bei agenturboomer.de';
      default:
        return title + ' | agenturboomer.de'
    }
  }

  const LinkTextEncode = encodeURIComponent(LinkText());

  const MessageText = () => {
    switch(type) {
      case 'job':
        return 'Jetzt Stellenangebot auschecken! 👇 ' + title + ' bei ' + company + ' | ' + shareUrl;
      case 'blog':
        return 'Lies jetzt den Artikel "' +  title + '" bei agenturboomer.de: ' + shareUrl;
      default:
        return title + ' | agenturboomer.de'
    }
  }

  const MessageTextEncode = encodeURIComponent(MessageText());

  return (
    <Wrapper>
      {/* LinkedIn */}
      <ShareItem
        className={'linkedin'}
        href={'https://www.linkedin.com/shareArticle?mini=true&url=' + shareUrl}
        title={'Stellenanzeige auf LinkedIn teilen'}
        external={true}
      ><LinkedInIcon/></ShareItem>

      {/* Xing */}
      <ShareItem
        className={'xing'}
        href={'https://www.xing.com/spi/shares/new?url=' + shareUrl}
        title={'Stellenanzeige auf Xing teilen'}
        external={true}
      ><XingIcon/></ShareItem>

      {/* twitter */}
      <ShareItem
        className={'twitter'}
        href={'https://twitter.com/intent/tweet?url=' + shareUrl + '&text=' + LinkTextEncode}
        title={'Stellenanzeige auf twitter teilen'}
        external={true}
      ><TwitterIcon/></ShareItem>

      {/* Link */}
      <ShareItem
        className={'link'}
        href={'#'}
        title={'Stellenanzeige als Link teilen'}
        onClick={() => {navigator.clipboard.writeText(shareUrl)}}
      ><LinkIcon/></ShareItem>

      {/* facebook */}
      {/*<ShareItem
        className={'facebook'}
        href={'https://www.facebook.com/sharer/sharer.php?u=' + Url}
        title={'Stellenanzeige auf LinkedIn teilen'}
        external={true}
      ></ShareItem>*/}

      {/* Mail */}
      {/*<ShareItem
        className={'mail'}
        href={'mailto:info@example.com?&subject=' + LinkTextEncode + '&cc=&bcc=&body=' + MessageTextEncode}
        title={'Stellenanzeige auf LinkedIn teilen'}
        external={true}
      ></ShareItem>*/}

      {/* WhatsApp */}
      {/*<ShareItem
        className={'whatsapp'}
        href={'https://wa.me/?text=' + MessageTextEncode}
        title={'Stellenanzeige auf LinkedIn teilen'}
        external={true}
      ></ShareItem>*/}
    </Wrapper>
  )
}